import PhoneCasesAdd from 'screens/AdminPanel/components/PhoneCases/components/PhoneCasesAdd/PhoneCasesAdd';
import PhoneCasesEdit from 'screens/AdminPanel/components/PhoneCases/components/PhoneCasesEdit/PhoneCasesEdit';
import TagsEdit from 'screens/AdminPanel/components/Tag/components/TagsEdit/TagsEdit';
import TagsAdd from 'screens/AdminPanel/components/Tag/components/TagsAdd/TagsAdd';
import { LoginForm, RegistrationForm } from 'components';
import LocalizationAdd from 'screens/AdminPanel/components/Localization/components/LocalizationAdd/LocalizationAdd';
import LocalizationEdit from 'screens/AdminPanel/components/Localization/components/LocalizationEdit/LocalizationEdit';
import { TModalConfigItem } from 'store/contexts/ModalContext/ModalContext.types';
import { MODALS } from '../../../constants/modalKeys';

// Re-export MODALS for backward compatibility
export { MODALS };

export const MODAL_TYPES = Object.freeze({
  REGULAR: 'REGULAR',
  SMALL: 'SMALL',
  LARGE: 'LARGE',
});

export const MODAL_CONFIGS = Object.freeze({
  // Admin
  [MODALS.ADMIN_PHONE_CASE_ADD]: {
    title: 'Add phone case',
    type: MODAL_TYPES.LARGE,
    Component: PhoneCasesAdd,
  },
  [MODALS.ADMIN_PHONE_CASE_EDIT]: {
    title: 'Edit phone case',
    type: MODAL_TYPES.LARGE,
    Component: PhoneCasesEdit,
  },
  [MODALS.ADMIN_TAG_ADD]: {
    title: 'Add tag',
    type: MODAL_TYPES.LARGE,
    Component: TagsAdd,
  },
  [MODALS.ADMIN_TAG_EDIT]: {
    title: 'Edit tag',
    type: MODAL_TYPES.LARGE,
    Component: TagsEdit,
  },
  [MODALS.REGISTRATION]: {
    title: 'Registration',
    type: MODAL_TYPES.SMALL,
    Component: RegistrationForm,
  },
  [MODALS.LOGIN]: {
    title: 'Login',
    type: MODAL_TYPES.SMALL,
    Component: LoginForm,
  },
  [MODALS.ADMIN_LOCALIZATION_ADD]: {
    title: 'Add static localization',
    type: MODAL_TYPES.LARGE,
    Component: LocalizationAdd,
  },
  [MODALS.ADMIN_LOCALIZATION_EDIT]: {
    title: 'Edit static localization',
    type: MODAL_TYPES.LARGE,
    Component: LocalizationEdit,
  },
}) as {
  readonly [K in keyof typeof MODALS]: TModalConfigItem;
};
